export enum ReportsActions {
    SET_REPORT = "setReport",
    SET_SELECTED_REPORTS = "setSelectedReports",
    SET_REPORT_DETAILS = "setReportDetails",
    TOGGLE_REPORTS_PANEL = "toggleReportsPanel",
    RELOAD_REPORTS = "reloadReports",
    CLEAR = "clearReports",
    PREPARE_REPORT = "prepareReport"
}